import type { CustomEvents } from '../models';

export const customEvents: CustomEvents = {
  load: 'livecodes-load',
  appLoaded: 'livecodes-app-loaded',
  ready: 'livecodes-ready',
  change: 'livecodes-change',
  testResults: 'livecodes-test-results',
  destroy: 'livecodes-destroy',
  resizeEditor: 'livecodes-resize-editor',
  apiResponse: 'livecodes-api-response',
};
